module.exports = __webpack_public_path__ + "img/goyoga-manager-nouveau-paradigme.f062929.jpeg";